import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {DEBTOR} from '../../../constants/MicroServiceConstants';

const initialData = {
  legalInformationData: {},
  legalInformationStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'legalInformation',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchLegalInformationData: (state, action) => {
      state.legalInformationData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postLegalInfoData: (state, action) => {
      state.legalInformationStatus = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetLegalInfo: (state) => {
      state.legalInformationStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchLegalInformationData,
  postLegalInfoData,
  fetchStart,
  resetMsg,
  fetchSuccess,
  resetLegalInfo,
  fetchError,
} = slice.actions;

export const fetchLegalInformation = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${DEBTOR}/find/legal/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchLegalInformationData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postLegalInformation = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/save/legal`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postLegalInfoData(data.status));
          dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetLegalInfoStatus = () => {
  return (dispatch) => {
    dispatch(resetLegalInfo());
  };
};
